// utm.js — Atribución al pedido.
//
// UTMs (2026-07-26): limpack.uy/r/{slug} redirige a la tienda con
// ?utm_source=...&utm_campaign={slug}. Captura una sola vez (first-touch)
// y guarda 7 días en localStorage. crear-pedido-publico los persiste en pedidos.utm_*.
//
// REF vendedor (2026-09-09): links de vendedores (limpack.uy/?ref=CODIGO)
// se capturan aparte y viven 30 días (last-touch: la última exposición gana
// mientras siga vigente). crear-pedido-publico resuelve el código a
// pedidos.vendedor_referido_id.

const KEY_UTM = 'limpack_utm_v1'
const TTL_UTM_MS = 7 * 24 * 60 * 60 * 1000

const KEY_REF = 'limpack_ref_v1'
const TTL_REF_MS = 30 * 24 * 60 * 60 * 1000
// sessionStorage marker: dura solo mientras ESTA pestaña esté abierta.
// Se setea cuando el ref llega en el querystring de la URL actual.
// El banner "Venís por X" se muestra solo si este marker existe — así
// la atribución de 30 días sigue viva (localStorage) pero el banner
// no persigue al cliente en visitas posteriores sin link.
const KEY_REF_SESSION = 'limpack_ref_session'

// ————— UTM (marketing / campañas orgánicas) —————

export function capturarUTM() {
  try {
    const qs = new URLSearchParams(window.location.search)
    const source = qs.get('utm_source')
    const campaign = qs.get('utm_campaign')
    if (!source && !campaign) return
    const nuevo = {
      source: source || null,
      medium: qs.get('utm_medium') || null,
      campaign: campaign || null,
      content: qs.get('utm_content') || null,
      slug: qs.get('utm_campaign') || null,
      at: Date.now(),
    }
    localStorage.setItem(KEY_UTM, JSON.stringify(nuevo))
  } catch { /* localStorage bloqueado: sin atribución, sin drama */ }
}

export function getUTM() {
  try {
    const raw = localStorage.getItem(KEY_UTM)
    if (!raw) return null
    const utm = JSON.parse(raw)
    if (!utm?.at || Date.now() - utm.at > TTL_UTM_MS) {
      localStorage.removeItem(KEY_UTM)
      return null
    }
    return { source: utm.source, medium: utm.medium, campaign: utm.campaign, content: utm.content, slug: utm.slug }
  } catch { return null }
}

// ————— REF vendedor —————

// Captura ?ref=CODIGO (case-insensitive) en la URL. Last-touch: sobreescribe
// cualquier ref anterior. El código se normaliza a minúsculas (así matchea
// porteros.slug del lado servidor).
// Además marca sessionStorage para que el banner "Venís por X" solo aparezca
// en la sesión de navegación donde el cliente llegó por el link.
export function capturarRef() {
  try {
    const qs = new URLSearchParams(window.location.search)
    const ref = qs.get('ref')
    if (!ref || typeof ref !== 'string') return
    const clean = ref.trim().toLowerCase()
    if (!clean || !/^[a-z0-9-]{3,32}$/.test(clean)) return
    localStorage.setItem(KEY_REF, JSON.stringify({ codigo: clean, at: Date.now() }))
    try { sessionStorage.setItem(KEY_REF_SESSION, clean) } catch {}
  } catch { /* localStorage bloqueado: sin atribución */ }
}

// Devuelve el código de referido vigente (string) o null.
// Este es el que usa el checkout para atribuir la venta (localStorage, 30 días).
export function getRef() {
  try {
    const raw = localStorage.getItem(KEY_REF)
    if (!raw) return null
    const obj = JSON.parse(raw)
    if (!obj?.codigo || !obj?.at || Date.now() - obj.at > TTL_REF_MS) {
      localStorage.removeItem(KEY_REF)
      return null
    }
    return obj.codigo
  } catch { return null }
}

// Devuelve el ref SOLO si el cliente llegó por el link en ESTA pestaña.
// Se usa para decidir si mostrar el banner "Venís por X" — sin esto, quien
// visitó una vez el link vería el banner por 30 días en cada visita.
// La atribución al pedido no depende de esto: sigue viva vía getRef().
export function getRefSession() {
  try { return sessionStorage.getItem(KEY_REF_SESSION) || null } catch { return null }
}

// Borra el ref (por si el vendedor pide que el cliente no le atribuya, o para tests).
export function limpiarRef() {
  try { localStorage.removeItem(KEY_REF) } catch {}
  try { sessionStorage.removeItem(KEY_REF_SESSION) } catch {}
}
